import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

export enum CredentialingDetailsReportFields {
  id = 'id',
  personId = 'personId',
  imageId = 'imageId',
  email = 'email',
  firstName = 'firstName',
  middleName = 'middleName',
  lastName = 'lastName',
  suffix = 'suffix',
  prefix = 'prefix',
  fullName = 'fullName',
  externalSystemId = 'externalSystemId',
  credentialDefinitionId = 'credentialDefinitionId',
  credentialName = 'credentialName',
  credentialNumber = 'credentialNumber',
  credentialStatusLabel = 'credentialStatusLabel',
  systemStatus = 'systemStatus',
  issueDate = 'issueDate',
  expirationDate = 'expirationDate',
  lastApplicationStartDate = 'lastApplicationStartDate',
  tags = 'tags',
  teamName = 'name',
  teamPublicName = 'publicName',
  workspaceName = 'workspaceName',
  specialties = 'specialties'
}

export const PersonCredentialingDetailsReportSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(CredentialingDetailsReportFields.firstName, '', 'First Name'),
  new ItemPickerModel(CredentialingDetailsReportFields.lastName, '', 'Last Name'),
  new ItemPickerModel(CredentialingDetailsReportFields.fullName, '', 'Full Name'),
  new ItemPickerModel(CredentialingDetailsReportFields.suffix, '', 'Suffix'),
  new ItemPickerModel(CredentialingDetailsReportFields.prefix, '', 'Prefix'),
  new ItemPickerModel(CredentialingDetailsReportFields.email, '', 'Email'),
  new ItemPickerModel(CredentialingDetailsReportFields.credentialName, '', 'Credential Name'),
  new ItemPickerModel(CredentialingDetailsReportFields.credentialNumber, '', 'Credential Number'),
  new ItemPickerModel(
    CredentialingDetailsReportFields.credentialStatusLabel,
    '',
    'Credential Status'
  ),
  new ItemPickerModel(CredentialingDetailsReportFields.issueDate, '', 'Issue Date'),
  new ItemPickerModel(CredentialingDetailsReportFields.expirationDate, '', 'Expiration Date'),
  new ItemPickerModel(
    CredentialingDetailsReportFields.lastApplicationStartDate,
    '',
    'Last Application Start Date'
  ),
  new ItemPickerModel(CredentialingDetailsReportFields.tags, '', 'Tags')
];

export const TeamCredentialingDetailsReportSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(CredentialingDetailsReportFields.teamName, '', 'Team Name'),
  new ItemPickerModel(CredentialingDetailsReportFields.teamPublicName, '', 'Team Public Name'),
  new ItemPickerModel(CredentialingDetailsReportFields.credentialName, '', 'Credential Name'),
  new ItemPickerModel(CredentialingDetailsReportFields.credentialNumber, '', 'Credential Number'),
  new ItemPickerModel(
    CredentialingDetailsReportFields.credentialStatusLabel,
    '',
    'Credential Status'
  ),
  new ItemPickerModel(CredentialingDetailsReportFields.issueDate, '', 'Issue Date'),
  new ItemPickerModel(CredentialingDetailsReportFields.expirationDate, '', 'Expiration Date'),
  new ItemPickerModel(
    CredentialingDetailsReportFields.lastApplicationStartDate,
    '',
    'Last Application Start Date'
  ),
  new ItemPickerModel(CredentialingDetailsReportFields.tags, '', 'Tags')
];

export enum CredentialTagFilterFields {
  id = 'id',
  text = 'text'
}
